var SearchOps = {
    matchField: (nodes, field, search, invert=false) => {
        var matching = new Set()

        nodes.forEach(
            node => {
                // TODO we don't need Object.keys, we can have it from templates' data
                var fieldNames = Object.keys(node.properties)
                var fieldName = null
                fieldNames.forEach(_fieldName => { if (_fieldName.match(new RegExp(field, 'i')) !== null) {fieldName = _fieldName} })

                var _found = false

                var nodeField = fieldName?node.properties[fieldName]:null
                if (nodeField) {
                    var rg = undefined
                    var validRegExp = true
                    try {
                        rg = new RegExp(search, 'i')
                    } catch (error) {
                        // pass-through
                        validRegExp = false
                    }

                    var tof = typeof nodeField
                    if (validRegExp && (tof ==='string' || nodeField instanceof String)) {



                        // if (validRegExp && search.match(/\$/g)!==null && nodeField!=='' && !isNaN(nodeField)) {
                        //     var s = search.replace(/\$/g, nodeField)
                        //     s = s.replace(/and/gi, '&&')
                        //     s = s.replace(/\=/gi, '==')
                        //     s = s.replace(/or/gi, '||')
                        //     s = s.replace(/not/gi, '!')
                        //     _found = (eval(s)===true)
                        // } else {
                            // if (validRegExp)
                            _found = (nodeField.match(rg) !== null)
                        // }
                    }
                    else if (validRegExp && Array.isArray(nodeField)) {
                        for (var ai=0; ai<nodeField.length; ai++) {
                            _found = (nodeField[ai].match(rg) !== null)
                            if (_found) {
                                break
                            }
                        }
                    } else {
                        console.log('%c Unrecognized field type', 'color: red; font-weight: 900', nodeField, field)
                    }
                }

                if ((_found && !invert) || (!_found && invert)) {
                    matching.add(node.id)
                }
            }
        )

        return matching
    },
    matchAny: (nodes, search, invert=false) => {
        var matching = new Set()

        // TODO we don't need Object.keys, we can extract which fileds exist from templates' data

        nodes.forEach(
            node =>  {
                var fields = Object.keys(node.properties)
                var _found = false
                for (var i=0; i<fields.length; i++) {
                    var nodeField = node.properties[fields[i]]
                    var tof = typeof nodeField

                    var rg = undefined
                    var validRegExp = true
                    try {
                        rg = new RegExp(search, 'i')
                    } catch (error) {
                        // pass-through
                        validRegExp = false
                    }

                    if (validRegExp && tof ==='string' || nodeField instanceof String) {
                        // if (search.match(/\$/g)!==null && nodeField!=='' && !isNaN(nodeField)) {
                        //     var s = search.replace(/\$/g, nodeField)
                        //     s = s.replace(/and/gi, '&&')
                        //     s = s.replace(/\=/gi, '==')
                        //     s = s.replace(/or/gi, '||')
                        //     s = s.replace(/not/gi, '!')
                        //     if (eval(s)===true) {
                        //         _found = true
                        //     }
                        // } else {
                            _found = _found || (nodeField.match(rg) !== null)
                        // }
                    }
                    else if (validRegExp && Array.isArray(nodeField)) {
                        for (var ai=0; ai<nodeField.length; ai++) {
                            if (nodeField[ai]!==null && (typeof nodeField[ai]==='object' || Array.isArray(nodeField[ai])) ) {
                                for (let key in nodeField[ai]) {
                                    if (typeof nodeField[ai][key] === 'string' && nodeField[ai][key].match(rg) !== null) {
                                        _found = true;
                                        break
                                    }
                                }
                                if (_found === true) break
                            }
                            else if (typeof nodeField[ai] === 'string' && nodeField[ai].match(rg) !== null) {
                                _found = true
                                break
                            }
                        }
                    }
                }
                if ((_found && !invert) || (!_found && invert)) {
                    matching.add(node.id)
                }
            }
        )

        return matching
    },
    union: (setA, setB) => {
        var union = new Set(setA)
        for (var elem of setB) {
            union.add(elem)
        }
        return union
    },
    unionInplace: (setA, setB) => {
        for (var elem of setB) {
            setA.add(elem)
        }
        return setA
    },
    intersect: (setA, setB) => {
        var intersection = new Set()
        for (var elem of setB) {
            if (setA.has(elem)) {
                intersection.add(elem)
            }
        }
        return intersection
    },
    link: (nodes, nodesHash, links, linksHash, setA) => {
        var neighborhood = new Set(setA)
        for (var nodeId of setA) {
            var node = nodes[nodesHash[nodeId]]
            for (var i=0; i<node.linksList.length; i++) {
                var link = links[linksHash[node.linksList[i]]]
                // TODO check if both sides of the linkage go as a result or just parent|child
                if (link.from_id === nodeId) {
                    neighborhood.add(link.to_id)
                }
                if (link.to_id === nodeId) {
                    neighborhood.add(link.from_id)
                }
            }
        }
        return neighborhood
    }
}

export default SearchOps


// WEBPACK FOOTER //
// ./src/components/SearchOps.js